export const airtable_text_format = (text) => {
    let new_text = '';
    if (text !== null && text !== undefined && text.length > 0) {
        let text_arr = text.split('\n');
        if (text_arr.length > 0) {
            for (let i = 0; i < text_arr.length; i++) {
                new_text += airtable_line_format(text_arr[i]);
            }

        }
    }
    return new_text;
}
export const airtable_line_format = (text_line) => {
    let new_text = '';
    if (text_line.indexOf('######') + 1 > 0) {
        new_text = text_line.replace('######', '<h6>') + '</h6>';
    } else {
        if (text_line.indexOf('#####') + 1 > 0) {
            new_text = text_line.replace('#####', '<h5>') + '</h5>';
        } else {
            if (text_line.indexOf('####') + 1 > 0) {
                new_text = text_line.replace('####', '<h4>') + '</h4>';
            } else {
                if (text_line.indexOf('###') + 1 > 0) {
                    new_text = text_line.replace('###', '<h3>') + '</h3>';
                } else {
                    if (text_line.indexOf('##') + 1 > 0) {
                        new_text = text_line.replace('##', '<h2>') + '</h2>';
                    } else {
                        if (text_line.indexOf('#') + 1 > 0) {
                            new_text = text_line.replace('#', '<h1>') + '</h1>';
                        } else {
                            new_text = '<p>' + text_line + '</p>';
                        }
                    }
                }
            }
        }
    }

    if (new_text.indexOf('**') + 1 > 0) {
        let strong_tag = false;
        while (new_text.indexOf('**') + 1 > 0){
            if (!strong_tag) {
                new_text = new_text.replace('**', '<strong>');
                strong_tag = true;
            } else{
                new_text = new_text.replace('**', '</strong>');
                strong_tag = false;
            }
        }
    }

    return new_text;
}